if (!customElements.get("common-media-banner")) {
  class commonMediaBanner extends HTMLElement {
    constructor() {
      super();
      this.swiperContainer = this.querySelector(".swiper");
    }
    connectedCallback() {
      this.initSwiper();
    }
    initSwiper() {
      let autoplayConfig = {};
      let autoplayDelay = Number(this.dataset?.autoplayInterval);
      let autoplaySpeed = Number(this.dataset?.autoplaySpeed);
      if (autoplayDelay !== 0) {
        autoplayConfig = {
          speed: autoplaySpeed * 1000,
          autoplay: {
            delay: autoplayDelay * 1000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
        };
      }

      // 获取相关元素
      this.paginationEl = this.querySelector(".swiper-pagination");
      this.nextEl = this.querySelector(".swiper-button-next");
      this.prevEl = this.querySelector(".swiper-button-prev");
      // 查看是否有pagination label需要展示
      const numberPaginationEl = this.querySelector(".number-pagination");
      let labelArray = null;
      if (this.paginationEl.dataset.labels !== "") {
        labelArray = this.paginationEl.dataset.labels.split(";");
      }
      this.swiper = new Swiper(this.swiperContainer, {
        loop: true,
        autoHeight: true,
        pagination: {
          el: this.paginationEl,
          clickable: true,
          ...(labelArray && {
            renderBullet: function (index, className) {
              return `<div data-index="${index}" class="pagination-item"><span class="${className}"></span><span>${labelArray[index]}</span></div>`;
            },
          }),
        },
        navigation: {
          nextEl: this.nextEl,
          prevEl: this.prevEl,
        },
        on: {
          slideChange: function () {
            numberPaginationEl.innerHTML = `${this.realIndex + 1}/${
              this.slides.length
            }`;
            const activeIndex = this.realIndex;
            const paginationEl = document.querySelector('.swiper-pagination');
            const activeBullet = paginationEl.querySelector(`[data-index="${activeIndex}"]`);
        
            if (activeBullet) {
              const bulletLeft = activeBullet.offsetLeft;
              const bulletWidth = activeBullet.offsetWidth;
              const containerWidth = paginationEl.clientWidth;
        
              const scrollTarget = bulletLeft - containerWidth / 2 + bulletWidth / 2;
        
              paginationEl.scrollTo({
                left: scrollTarget,
                behavior: 'smooth',
              });
            }
          },
        },
        ...autoplayConfig,
      });

      // 初始化 number pagination元素内容
      numberPaginationEl.innerHTML = `${this.swiper.realIndex + 1}/${
        this.swiper.slides.length
      }`;

      // 解决轮播图首次加载好自动播放时，第一个banner没有进度条的问题
      this.firstBannerPaginator = this.querySelector(
        ".swiper-pagination-bullet:nth-child(1)"
      );
      this.firstBannerPaginator.classList.remove(
        "swiper-pagination-bullet-active"
      );
      setTimeout(() => {
        this.firstBannerPaginator.classList.add(
          "swiper-pagination-bullet-active"
        );
      });
    }
  }

  customElements.define("common-media-banner", commonMediaBanner);
}
